// src/App.js
import './App.css';

import { NavBar }         from './component/NavBar';
import { Banner }         from './component/Banner';
import { Projects }       from './component/Projects';
import { Contact }        from './component/Contact';
import { Footer }         from './component/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Pricing } from './component/Pricing';

// ── Main page layout ─────────────────────────────────────────────
function App() {
  return (
    <div className="App">
      <NavBar />
        <Pricing />
      <Banner />
    
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}
export default App;